export default __webpack_public_path__ + "static/media/Lets stay home menu.31be5a11.jpg";